import { PropsWithChildren } from 'react';

export interface ComponentProps {}
export const DefaultFormPanel: React.FC<PropsWithChildren<ComponentProps>> = ({ children }) => {
  return <div className="default-form panel-card">{children}</div>;
};
